var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenuClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 17 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.50152 0C1.22538 0 1.00152 0.223858 1.00152 0.5C1.00152 0.776142 1.22538 1 1.50152 1H16.5015C16.7777 1 17.0015 0.776142 17.0015 0.5C17.0015 0.223858 16.7777 0 16.5015 0H1.50152ZM6.75152 6C6.47538 6 6.25152 6.22386 6.25152 6.5C6.25152 6.77614 6.47538 7 6.75152 7H15.7515C16.0277 7 16.2515 6.77614 16.2515 6.5C16.2515 6.22386 16.0277 6 15.7515 6H6.75152ZM1.00152 12.5C1.00152 12.2239 1.22538 12 1.50152 12H16.5015C16.7777 12 17.0015 12.2239 17.0015 12.5C17.0015 12.7761 16.7777 13 16.5015 13H1.50152C1.22538 13 1.00152 12.7761 1.00152 12.5ZM2.674 4.765C2.82035 4.53083 2.74917 4.22236 2.515 4.076C2.28083 3.92965 1.97236 4.00083 1.826 4.235L0.576001 6.235C0.474666 6.39714 0.474666 6.60286 0.576001 6.765L1.826 8.765C1.97236 8.99917 2.28083 9.07035 2.515 8.924C2.74917 8.77764 2.82035 8.46917 2.674 8.235L1.58962 6.5L2.674 4.765Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuClose);
export default __webpack_public_path__ + "static/media/menuClose.efb620ed5432b765e27967dc7e08dbf7.svg";
export { ForwardRef as ReactComponent };